<template>
  <InstagramToolPage
    h1-title="Instagram Photo Downloader"
    subtitle="Download photos from public Instagram posts by pasting the post link."
    input-placeholder="Paste Instagram post URL here"
    action-label="Download"
    limitation-note="Public Instagram content only."
    current-tool-path="/instagram-photo-downloader/"
    :faqs="faqs"
  >
    <ToolContentSections :sections="photoDownloaderSections" />
  </InstagramToolPage>
</template>

<script>
import InstagramToolPage from '@/components/InstagramToolPage.vue';
import ToolContentSections from '@/components/ToolContentSections.vue';
import { photoDownloaderSections } from '@/data/instagram-tool-page-content';

export default {
  name: 'InstagramPhotoDownloaderPage',
  components: { InstagramToolPage, ToolContentSections },
  data () {
    return {
      photoDownloaderSections,
      faqs: [
        {
          question: 'Can I download photos from private accounts?',
          answer: 'No. Only public posts that Instagram still exposes for the URL can be processed.',
        },
        {
          question: 'Will I get the original quality?',
          answer: 'You get the best quality Instagram returns for that link, which may be compressed compared with the creator’s original file.',
        },
        {
          question: 'How do carousels work?',
          answer: 'Paste the carousel post link once. If multiple images are available, each appears as a separate download option.',
        },
        {
          question: 'Is this free?',
          answer: 'Yes. SnapInsta does not charge for parsing supported public post links.',
        },
      ],
    };
  },
};
</script>
